import React from 'react'
import { makeStyles } from '@material-ui/styles'
import PropTypes from 'prop-types'
import { Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText, Typography } from '@material-ui/core'
import { Button, TextField } from '@michelin/acid-components'
import { FormattedMessage } from 'react-intl'
import clsx from 'clsx'

const classStyles = makeStyles(theme => ({
	buttonProgress: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		marginTop: theme.spacing(1),
		marginLeft: theme.spacing(2),
	},
	dialogError: {
		color: theme.palette.error.primary
	},
	build: {
		flex: 1,
		fontSize: '.5em',
		color: theme.palette.text.secondary
	},
}))

const LoggedOutWidget = (props) => {
	const classes = classStyles(props)
	const [username, setUsername] = React.useState(null)
	const [password, setPasswrod] = React.useState(null)

	const { className, environment, error, isLoading, onLogin } = props

	const handleModalLogin = () => {
		onLogin(username, password)
	}

	const handleUsernameChanged = (event) => {
		setUsername(event.target.value)
	}

	const handlePasswordChanged = (event) => {
		setPasswrod(event.target.value)
	}

	const handleKeyPress = (event) => {
		if (event.key === 'Enter') handleModalLogin()
	}

	const version = '1.2.4' + (environment ? ' - ' + environment : '')

	return (
		<Dialog
			className={clsx(className)}
			open={true}
			aria-labelledby="form-dialog-title"
		>
			<DialogTitle id="form-dialog-title">
				<div style={{ display: 'flex' }}>
					<div>
						<FormattedMessage id="app.title" /> - <FormattedMessage id="app.login" />
					</div>
					<Typography align="right" className={classes.build}>{version}</Typography>
				</div>
			</DialogTitle>
			<DialogContent>
				<TextField
					autoFocus
					label={<FormattedMessage id="app.username" />}
					onChange={handleUsernameChanged}
					onKeyPress={handleKeyPress}
				/>
				<TextField
					type="password"
					label={<FormattedMessage id="app.password" />}
					onChange={handlePasswordChanged}
					onKeyPress={handleKeyPress}
				/>
				<DialogContentText color="error" className={classes.dialogError}>
					{error ? error.message : ''}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button color="primary" onClick={handleModalLogin} disabled={isLoading}>
					<FormattedMessage id="app.login" />
				</Button>
			</DialogActions>
		</Dialog>
	)
}

LoggedOutWidget.propTypes = {
	environment: PropTypes.string,
	onLogin: PropTypes.func,
	classes: PropTypes.object,
	error: PropTypes.object,
	isLoading: PropTypes.bool
}

export default LoggedOutWidget


// WEBPACK FOOTER //
// ./src/components/LoggedOutWidget.js